import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconsLibraryService } from '@ps/core-config';
import {
  LoadingComponent,
  LoadingService,
  ToastComponent,
} from '@ps/core-overlay';

@Component({
  standalone: true,
  imports: [RouterOutlet, ToastComponent, LoadingComponent],
  providers: [IconsLibraryService],
  selector: 'ps-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly _iconsLibraryService = inject(IconsLibraryService);

  private readonly _loadingService = inject(LoadingService);

  protected readonly pageLoading = this._loadingService.isLoading('page');

  constructor() {
    this._iconsLibraryService.register();
  }
}
